import React, { Component } from 'react'
import update from 'immutability-helper'
import PropTypes from 'prop-types'

import Select, { Creatable } from 'react-select'
import { Draggable } from 'react-beautiful-dnd'

class MemberItems extends Component {
  constructor(props) {
    super(props)

    this.state = {
      items: [],
      showItemSelector: false,
      itemSelectorValue: '',
      itemSelectorIsLoading: false,
      selectedItem: undefined,
      showTypeSelector: false,
      searchInputTimeout: null
    }

    this.selector = React.createRef()
    this.typeSelector = React.createRef()
  }

  componentWillMount() {
    const { items, options, categories, searchResults } = this.props

    this.setState({items})
    if (searchResults === undefined && (options || categories)) this.getInitialSearchResults(options, categories, searchResults)
  }

  componentWillReceiveProps(nextProps) {
    const { options, categories, searchResults } = nextProps

    if (searchResults === undefined && ((options && this.props.options === undefined) || (categories && this.props.categories === undefined))) this.getInitialSearchResults(options, categories, searchResults)
  }

  componentWillUnmount() {
    if (this.state.searchInputTimeout) clearTimeout(this.state.searchInputTimeout)
  }

  getInitialSearchResults(options, categories, searchResults) {
    this.setState({itemSelectorIsLoading: false}, () => {
      this.props.getSearchResults(
        options && options.length > 0
        ? options
        : categories,
        this.state.itemSelectorValue
      )
    })
  }

  setSelectorFocus(selector, value, searchResults) {
    this.setState({
      itemSelectorIsLoading: searchResults === undefined ? true : false
    }, () => {
      const { select } = selector.current
      if (select) selector.current.select.handleInputChange({target: {value: (value && value.title) || ''}})
    })
  }

  clearSearchResults() {
    this.props.getSearchResults([])
  }

  clearFocus() {
    this.setState({
      showItemSelector: false,
      selectedItem: undefined,
      showTypeSelector: false
    }, () => this.props.setFocus(false))
  }

  getOptions = (input) => {
    if (this.state.searchInputTimeout) clearTimeout(this.state.searchInputTimeout)

    const searchInputTimeout = setTimeout(() => {
      const { options, searchResults } = this.props

      this.props.getSearchResults(options, input)

      if (searchResults !== undefined) this.setState({itemSelectorIsLoading: false})
    }, 500)

    this.setState({itemSelectorIsLoading: input.length > 0 ? true : false, searchInputTimeout})
  }

  renderSelectForm() {
    const { items, availableItems, categories, searchResults } = this.props
    const { itemSelectorValue, itemSelectorIsLoading, selectedItem, showTypeSelector } = this.state

    const value = selectedItem

    return (
      <div className="select-form">
        <div className="select-form-escape" onClick={() => this.clearFocus()} />

        <div className="select-form-fields">
          <label>
            {
              itemSelectorValue.length > 0 || selectedItem
              ? 'Add new instrument to input list'
              : 'Select existing or type for new'
            }
          </label>

          <Creatable ref={this.selector}
            cache={false}
            autoFocus={true}
            openOnFocus={true}
            isLoading={itemSelectorIsLoading}
            className="select-form-field"
            value={value}
            valueKey="id"
            labelKey="title"
            placeholder={null}
            loadingPlaceholder={null}
            searchPromptText="Search prompts"
            promptTextCreator={(label) => `Add "${label}"`}
            clearable={false}
            onOpen={() => this.setSelectorFocus(this.selector, value, searchResults)}
            onInputChange={(input) => {
              this.setState({itemSelectorValue: input}, () => this.getOptions(input))

              return input
            }}
            onChange={(value) => {
              if (value) {
                value.position === undefined
                ? this.props.createRiderItem(value)
                : this.setState({items: update(items, {$push: [value]})}, () => this.props.updateMember(this.state.items))
              }

              this.clearSearchResults()
              this.clearFocus()
            }}
            onNewOptionClick={(value) => {
              const selectedItem = {title: value.title, type: undefined}
              this.setState({selectedItem, showTypeSelector: true}, () => this.typeSelector.current.focus())
            }}
            onBlur={() => {
              this.clearSearchResults()
            }}
            noResultsText={searchResults !== undefined ? 'Add instruments by typing' : 'Loading results...'}
            options={
              itemSelectorValue.length > 0 || availableItems.length === 0
              ? searchResults
              : availableItems
            } />

          {
            showTypeSelector
            ? <hr />
            : null
          }

          {
            showTypeSelector
            ? <Select
                ref={this.typeSelector}
                openOnFocus={true}
                className="select-form-field"
                value={undefined}
                valueKey="id"
                labelKey="title"
                clearable={false}
                placeholder={`Specify it's category`}
                noResultsText={categories.length > 0 ? 'Clear field to select an existing category' : 'Loading results...'}
                onChange={(value) => {
                  this.props.createRiderItem({title: selectedItem.title, type: value.type})
                  this.clearFocus()
                }}
                options={categories} />
            : null
          }
        </div>
      </div>
    )
  }

  render() {
    let { view, items } = this.props
    const { showItemSelector } = this.state

    return (
      <div className="member-items">
        <ul>
          {
            items.map((item, index) => (
              <Draggable key={index} draggableId={item.id} isDragDisabled={true} type="member-items">
                {(provided, snapshot) => (
                  <li ref={provided.innerRef}>
                    <div className="member-item" style={provided.draggableStyle}
                      {...provided.dragHandleProps}>
                      {
                        view.editable
                        ? <span className="remove-item" onClick={() => {
                            items = update(items, {$splice: [[index, 1]]})
                            this.setState({items}, () => this.props.updateMember(items))
                          }} />
                        : null
                      }

                      {item.title}
                    </div>

                    {provided.placeholder}
                  </li>
                )}
              </Draggable>
            ))
          }
        </ul>

        {
          view.editable
          ? showItemSelector
            ? this.renderSelectForm()
            : <div>
                <a className="link--invert" onClick={() => this.setState({showItemSelector: true}, () => this.props.setFocus(true))}>+ Add instrument</a>
              </div>
          : null
        }
      </div>
    )
  }
}

MemberItems.propTypes = {
  view: PropTypes.object,
  items: PropTypes.array,
  setFocus: PropTypes.func,
  createRiderItem: PropTypes.func,
  updateMember: PropTypes.func,
  createRiderMember: PropTypes.func,
  editRiderMember: PropTypes.func,
  availableItems: PropTypes.array,
  options: PropTypes.array,
  categories: PropTypes.array,
  searchResults: PropTypes.array,
  getSearchResults: function() {}
}

MemberItems.defaultProps = {
  view: {},
  items: [],
  setFocus: function() {},
  createRiderItem: function() {},
  updateMember: function() {},
  createRiderMember: function() {},
  editRiderMember: function() {},
  availableItems: [],
  options: undefined,
  categories: undefined,
  searchResults: undefined,
  getSearchResults: function() {}
}

export default MemberItems



// WEBPACK FOOTER //
// ./src/components/rider/rider-members/member-items.js